import Image from 'next/image';
import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(20)};
    position: relative;
`;

export const Photos = styled.div`
    padding: ${rem(20)} 0;
    max-width: ${rem(800)};
`;

export const PhotoContainer = styled.div`
    
`;

export const Photo = styled(Image)`
    width: 95%;
    height: auto;
    border-radius: ${rem(16)};
    margin-right: ${rem(10)};
    cursor: pointer;
`;
